import { combineReducers } from 'redux'
import status from './status'
import auth from './auth'
import entities from './entities'
import { persistReducer, createMigrate } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const migrations = {
  0: () => null
}

const persistConfig = {
  key: 'root',
  version: 0,
  whitelist: ['auth', 'entities'],
  storage,
  timeout: null,
  migrate: createMigrate(migrations, { debug: true })
}

const reducer = combineReducers({
  auth,
  status,
  entities
})

export default persistReducer(persistConfig, reducer)
